import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "../../../assets/css/admin/adminDashboard.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Simple Icons (emoji style close to image look)
const IconBox = ({ bg, children }) => (
  <div className="icon-box" style={{ background: bg }}>
    {children}
  </div>
);

const AdminDashboard = () => {
  const { baseUrl, loggedInSeller } = useContext(AppContext);
  const navigate = useNavigate();
  const [ordersData, setOrdersData] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const seller = JSON.parse(localStorage.getItem("loggedInSeller") || "null");
  useEffect(() => {
    viewOrders();
    fetchAllTickets();
    fetchDashboard();
  }, []);
  const viewOrders = () => {
    const sellerId = loggedInSeller?.id;

    if (!sellerId) return;

    const formData = new FormData();
    formData.append("tpshop_id", sellerId);

    axios
      .post(`${baseUrl}/seller/orders/viewOrders`, formData)
      .then((response) => {
        setOrdersData(response.data.orders);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchAllTickets = () => {
    // const formData = new FormData();

    axios
      .get(`${baseUrl}/admin/helpsupport/fetchAllTickets`)
      .then((res) => {
        console.log("All tickets", res.data);
        if (res.data.success == true) {
          setTickets(res.data.tickets);
        }
      })
      .catch((err) => {
        console.log(err.response?.data);
      });
  };

  const fetchDashboard = () => {
    setLoading(true);

    axios
      .post(`${baseUrl}/admin/dashboard`)
   .then((response) => {
  console.log("Dashboard Response:", response.data);

  if (response.data.success) {
    setDashboard(response.data);
  }
})
      .catch((error) => {
        console.log(error);

        setLoading(false);
      });
  };
  return (
    <AdminMasterLayout>
      <div className="ad-content">
        <h2 className="title">Dashboard Overview</h2>

        {/* ───── STAT CARDS ───── */}
        <Row className="g-3 mb-4">
          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                <IconBox bg="#fff7ed">📦</IconBox>
                <span>Total Orders Received</span>
                
              </div>
              <h4>{dashboard?.cards.totalOrders}</h4>
              {/* <p className="up">+12%</p> */}
            </div>
          </Col>

          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                <IconBox bg="#eef2ff">✔</IconBox>
                <span>Orders Completed</span>
                
              </div>
              <h4>{dashboard?.cards.completedOrders}</h4>
              {/* <p className="up">+8%</p> */}
            </div>
          </Col>

          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                <IconBox bg="#fef3c7">⚠</IconBox>
                <span>Order Disputes</span>
                
              </div>
              <h4>{dashboard?.cards.disputes}</h4>
              {/* <p className="down">-3%</p> */}
            </div>
          </Col>

          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                <IconBox bg="#ede9fe">💰</IconBox>
                <span>Total Revenue</span>
              </div>
              <h4>PKR {dashboard?.cards.revenue}</h4>
              {/* <p className="up">+15%</p> */}
            </div>
          </Col>

          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                <IconBox bg="#f0fdf4">👤</IconBox>
                <span>Total Users</span>
                
              </div>
              <h4>{dashboard?.cards.users}</h4>
              {/* <p className="up">+5%</p> */}
            </div>
          </Col>

          <Col md={4}>
            <div className="stat-card">
              <div className="card-head">
                 <IconBox bg="#fff7ed">🏪</IconBox>
                <span>Active Shops</span>
               
              </div>
              <h4>{dashboard?.cards.shops}</h4>
              {/* <p className="up">+10%</p> */}
            </div>
          </Col>
        </Row>

        {/* ───── MIDDLE ───── */}
        <Row className="g-3 mb-3">
          {/* Activities */}
          {/* <Col md={5}>
            <div className="ad-card fixed-card">
              <h6>Recent Activities</h6>

              <div className="scroll-area">

                <div className="activity-item">
                  <div className="activity-icon blue">⚡</div>
                  <div>
                    <p>New order received</p>
                    <span>2 min ago</span>
                  </div>
                </div>

                <div className="activity-item">
                  <div className="activity-icon green">✔</div>
                  <div>
                    <p>Order completed</p>
                    <span>15 min ago</span>
                  </div>
                </div>

                <div className="activity-item">
                  <div className="activity-icon red">⚠</div>
                  <div>
                    <p>Dispute raised</p>
                    <span>1 hour ago</span>
                  </div>
                </div>

                <div className="activity-item">
                  <div className="activity-icon yellow">👤</div>
                  <div>
                    <p>New seller added</p>
                    <span>2 hours ago</span>
                  </div>
                </div>

              </div>
            </div>
          </Col> */}

          {/* Orders */}
          <Col md={12}>
            <div className="ad-card">
              <h6>Recent Orders</h6>

              <table className="table">
                <thead>
                  <tr>
                    <th>Order</th>
                    <th>Customer</th>
                    <th>Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {dashboard?.recentOrders?.length > 0 ? (
                    dashboard.recentOrders.map((order) => (
                      <tr key={order.id}>
                        {/* Order ID */}
                        <td>#{order.id}</td>

                        {/* Customer */}
                        <td>
                          {order.tpcustomer?.fullname ||
                            order.tpcustomer?.fullName ||
                            order.tpcustomer?.name ||
                            "N/A"}
                        </td>

                        {/* Status */}
                        <td>
                          <span
                            className={`badge ${
                              order.status === "complete"
                                ? "bg-success"
                                : order.status === "ongoing"
                                  ? "bg-primary"
                                  : order.status === "cancelled"
                                    ? "bg-danger"
                                    : "bg-warning text-dark"
                            }`}
                          >
                            {order.status === "complete"
                              ? "Completed"
                              : order.status === "ongoing"
                                ? "Ongoing"
                                : order.status === "cancelled"
                                  ? "Cancelled"
                                  : "Pending"}
                          </span>
                        </td>

                        {/* Amount */}
                        <td>
                          PKR {Number(order.amount || 0).toLocaleString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        No recent orders found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>

        {/* ───── BOTTOM ───── */}
        <Row className="g-3">
          <Col md={12}>
            <div className="ad-card ticket-section">
              <div className="ticket-header">
                <div className="d-flex align-items-center gap-2">
                  <span className="ticket-icon">⊘</span>
                  <h6 className="mb-0">Recent Support Tickets</h6>
                </div>

                <button
                  className="view-all-btn"
                  onClick={() => navigate("/admin-supports")}
                >
                  View all →
                </button>
              </div>

              <div className="ticket-list">
                {tickets.length > 0 ? (
                  tickets.slice(0, 5).map((ticket) => (
                    <div className="ticket-card" key={ticket.id}>
                      <div className="ticket-left">
                        <h6>{ticket.title}</h6>

                        <p>
                          {ticket.ticket_id} •{" "}
                          {new Date(ticket.created_at).toLocaleDateString(
                            "en-GB",
                          )}
                        </p>
                      </div>

                      <button
                        className={`ticket-status ${
                          ticket.status === "resolved" ||
                          ticket.status === "closed"
                            ? "resolved"
                            : "open"
                        }`}
                        onClick={() => navigate("/admin-supports")}
                      >
                        {ticket.status === "resolved" ||
                        ticket.status === "closed"
                          ? "Resolved"
                          : "Open"}
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="no-ticket">No support tickets found.</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </AdminMasterLayout>
  );
};

export default AdminDashboard;
